<div class="container book-widget-container">
  <div #inMobile class="d-block d-lg-none"></div>
  <form [formGroup]="bookWidgetForm" novalidate>
    <div class="form-row">
      <div class="col-lg-11 pl-xxl-0 pt-sm-3">
        <div class="row">
          <div
            class="col-lg-4 text-center offset-md-2 col-md-8 offset-lg-0 p-0"
            formGroupName="airports"
          >
            <div class="row">
              <a
                #deptAirportLookupDir="ngcAirportLookupDirective"
                (click)="
                  deptAirportLookupDir?.openLookupModal(0);
                  setSavedSearchesAirport(customerId)
                "
                (savedFromToAirport)="
                  setSaved($event); openBookWidgetInModal($event)
                "
                (searchedAirportCode)="fromAirportcode = $event; fromCity = ''"
                (selectedAirport)="
                  setFromAirport($event); openBookWidgetInModal($event)
                "
                (selectedRecentSearch)="
                  displayRecentSearch($event); openBookWidgetInModal($event)
                "
                [initialLookupKey]="fromAirportcode"
                [lookupTitle]="'Origin'"
                [recentSearchSelected]="recentSearches"
                [recentSearchsAvailable]="recentSearchsAvailable"
                [savedSearchesAvailable]="savedSearchesAvailable"
                [savedSearches]="savedSearches"
                aria-haspopup="true"
                class="from-container col-5 col-lg-5 col-sm-5 order-1 p-0 no-underline"
                href="javascript:void(0);"
                ngc-airport-lookup-directive
              >
                <span
                  [innerHTML]="
                    fromAirportcode && fromAirportcode !== ''
                      ? fromAirportcode
                      : fromAirportLabel
                  "
                  class="airport-code d-block"
                ></span>
                <span class="sr-only">Departure Airport or City</span>
                <span
                  [innerHTML]="
                    fromCity !== null &&
                    fromCity !== undefined &&
                    fromAirportcode &&
                    fromAirportcode !== ''
                      ? fromCity
                      : content?.travelOrigin
                  "
                  class="airport-desc"
                ></span>
                <input
                  [(ngModel)]="fromAirportcode"
                  [formControlName]="'fromAirportcode'"
                  name="fromAirportCode"
                  type="hidden"
                />
                <input
                  [(ngModel)]="fromCity"
                  [formControlName]="'fromCity'"
                  name="fromCity"
                  type="hidden"
                />
              </a>
              <a
                #toAirportLookupDir="ngcAirportLookupDirective"
                (click)="
                  toAirportLookupDir?.openLookupModal(0);
                  setSavedSearchesAirport(customerId)
                "
                (savedFromToAirport)="
                  setSaved($event); openBookWidgetInModal($event)
                "
                (searchedAirportCode)="toAirportcode = $event; toCity = ''"
                (selectedAirport)="
                  setToAirport($event); openBookWidgetInModal($event)
                "
                (selectedRecentSearch)="
                  displayRecentSearch($event); openBookWidgetInModal($event)
                "
                [initialLookupFromKey]="fromAirportcode"
                [initialLookupKey]="toAirportcode"
                [lookupTitle]="'Destination'"
                [recentSearchSelected]="recentSearches"
                [recentSearchsAvailable]="recentSearchsAvailable"
                [savedSearchesAvailable]="savedSearchesAvailable"
                [savedSearches]="savedSearches"
                aria-haspopup="true"
                class="to-container col-5 col-lg-5 col-sm-5 order-3 p-0 no-underline"
                href="javascript:void(0);"
                ngc-airport-lookup-directive
              >
                <span
                  [innerHTML]="
                    toAirportcode && toAirportcode !== ''
                      ? toAirportcode
                      : toAirportLabel
                  "
                  class="airport-code d-block"
                ></span>
                <span class="sr-only">Destination Airport or City</span>
                <span
                  [innerHTML]="
                    toCity !== null &&
                    toCity !== undefined &&
                    toAirportcode &&
                    toAirportcode !== ''
                      ? toCity
                      : content?.travelDestinationLabel
                  "
                  class="airport-desc"
                ></span>
                <input
                  [(ngModel)]="toAirportcode"
                  [formControlName]="'toAirportcode'"
                  name="arrivalCity"
                  type="hidden"
                />
                <input
                  [(ngModel)]="toCity"
                  [formControlName]="'toCity'"
                  name="toCity"
                  type="hidden"
                />
              </a>
              <div class="swap-container col-2 col-lg-2 col-sm-2 order-2 p-0">
                <a
                  (click)="swapCity()"
                  class="swapfield icon-swap d-inline-block"
                  href="javascript:void(0);"
                  role="button"
                  title="Reverse origin and destination city or airport"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-row align-items-center">
      <div
        class="d-lg-none book-expander text-center col-sm-12 offset-md-2 col-md-8 offset-lg-0"
      >
        <a
          (click)="expandBookWidgetInModal()"
          class="expand-container icon-expander align-bottom d-inline-block"
          href="javascript:void(0);"
          id="mobile-expand-widg"
          role="button"
          title="Expand Book Widget"
        ></a>
      </div>
    </div>
  </form>
</div>
